const ns = "EVENT";
export const REQUEST = `${ns}_REQUEST`;
export const RECEIVE = `${ns}_RECEIVE`;
export const RECEIVE_EVENT_HOME_ACCOUNT_RECORD_TYPES = `${ns}_RECEIVE_EVENT_HOME_ACCOUNT_RECORD_TYPES`;
export const GET_ERROR = `${ns}_GET_ERROR`;
